/**
 *   Import
 *   - Libraries
 */
 import * as React from 'react'
 import { ActionCreator } from 'redux'
 import { FormikState } from 'formik'
 import { History } from 'history'

/**
 *   Import
 *   - Actions
 */
 import { ForgotTriggerAction } from '../../../actions'

/**
 *   Import
 *   - Components
 */
 import { Logo } from '../../common/Logo/Logo'
 import { LoginWrapper } from '../Login/components/LoginWrapper/LoginWrapper'
 import ForgotForm from '../../../containers/pages/ForgotForm/ForgotForm'
 import { StyledLink } from '../Login/components/Link/Link.glamorous'
 import { Values } from '../../../containers/pages/ForgotForm/ForgotForm'

/**
 * Props
 * @type {Object}
 */
 export type Props = {
    error: any;
    history: History;
    loading: boolean;
    forgot: ActionCreator<ForgotTriggerAction>;
    userSession: object;
    userError: string;
    forgotStatus: boolean;
 }

 export const Forgot: React.SFC<Props & FormikState<Values>> = (props) => {
    return (
        <LoginWrapper>
            <Logo />
            <ForgotForm {...props} />
            {(!props.forgotStatus) ? (<StyledLink to="/login">Login</StyledLink>) : null}
        </LoginWrapper>
        )
 }



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Forgot/Forgot.tsx